import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import {
  authConfig,
  isPublicEndpoint,
  isFileUploadEndpoint,
  isHybridEndpoint,
} from '../config/interceptor.config';

function addAuthHeader(req: HttpRequest<unknown>, token: string) {
  return req.clone({
    setHeaders: { Authorization: `${authConfig.tokenPrefix} ${token}` },
  });
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!authConfig.enabled) return next(req);
  if (isPublicEndpoint(req.url)) return next(req);

  const token = localStorage.getItem(authConfig.tokenKey);

  if (isHybridEndpoint(req.url)) {
    return next(token ? addAuthHeader(req, token) : req);
  }
  if (isFileUploadEndpoint(req.url)) {
    return next(token ? addAuthHeader(req, token) : req);
  }
  if (token) {
    return next(addAuthHeader(req, token));
  }
  return next(req);
};

